import gql from 'graphql-tag';

export const ListKeywordsQuery = gql`
  {
    Keywords {
      _id
      value
      last_cleaned_at
    }
  }
`;

export const CreateKeywordMutation = gql`
  mutation($keyword: JSON) {
    createKeyword(record: $keyword) {
      _id
      value
      last_cleaned_at
    }
  }
`;

export const DeleteKeywordMutation = gql`
  mutation($query: JSON) {
    deleteKeyword(query: $query)
  }
`;
